import {
    React, RouteComponentProps,
    Formsy, form, formHelpers,
    i18n,
    observable, inject, observer,
    mui, ui, theme, pr,
    debug, helpers
} from "aaa";
import { User } from "models/User";
import { AnimDiv } from "@aaa/animdiv";
import * as _ from "lodash";

type IProps = i18n.InjectedIntlProps & {
    user: User
};

@i18n.injectIntl
@inject("user")
@observer
export class ExpensesContent extends React.Component<IProps, {}> {

    @observable
    otherDescriptionVisible = this.props.user.expenses.other.value > 0;

    @observable
    healthInsuranceVisible = this.props.user.expenses.healthInsurance.value > 0;

    render() {
        return (
            <div>
                {this.props.user.residenceStatusKey === "residence.rent" &&
                    < form.FormsyText
                        name="expensesRent"
                        validations="isPositiveCurrency"
                        floatingLabelText={ui.__("expenses.rent")}
                        fullWidth={true}
                        value={this.props.user.expenses.rent.toStringShort()}
                        validationError={ui.__("error.currencyInvalid")}
                    />}

                <form.FormsyText
                    name="expensesUtilities"
                    validations="isPositiveCurrency"
                    floatingLabelText={ui.__("expenses.utilities")}
                    fullWidth={true}
                    value={this.props.user.expenses.utilities.toStringShort()}
                    validationError={ui.__("error.currencyInvalid")}
                />

                <form.FormsyText
                    name="expensesOtherLoans"
                    validations="isPositiveCurrency"
                    floatingLabelText={ui.__("expenses.otherLoans")}
                    fullWidth={true}
                    value={this.props.user.expenses.otherLoans.toStringShort()}
                    validationError={ui.__("error.currencyInvalid")}
                />

                <form.FormsyText
                    name="expensesInsurances"
                    validations="isPositiveCurrency"
                    floatingLabelText={ui.__("expenses.insurances")}
                    fullWidth={true}
                    value={this.props.user.expenses.insurances.toStringShort()}
                    validationError={ui.__("error.currencyInvalid")}
                />

                {formHelpers.renderYesNoGroup(ui.__("expenses.haveHealthInsurance"), "haveHealthInsurance",
                    this.props.user.expenses.healthInsurance.value > 0,
                    (event: any, value: any) => {
                        this.healthInsuranceVisible = value === "yes";
                    })}
                <AnimDiv>{
                    this.healthInsuranceVisible &&
                    <form.FormsyText
                        name="expensesHealthInsurance"
                        required
                        validations="isPositiveCurrency"
                        floatingLabelText={ui.__("expenses.healthInsurance")}
                        fullWidth={true}
                        value={this.props.user.expenses.healthInsurance.toStringShort()}
                        validationError={ui.__("error.currencyInvalid")}
                    />
                }</AnimDiv>

                <form.FormsyText
                    name="expensesNumberOfCars"
                    validations="isInt"
                    floatingLabelText={ui.__("expenses.numberOfCars")}
                    fullWidth={true}
                    value={this.props.user.expenses.numberOfCars}
                    validationError={ui.__("error.formatInvalid")}
                />

                <form.FormsyText
                    name="expensesOther"
                    validations="isPositiveCurrency"
                    floatingLabelText={ui.__("expenses.other")}
                    fullWidth={true}
                    value={this.props.user.expenses.other.toStringShort()}
                    validationError={ui.__("error.currencyInvalid")}
                    onChange={(e: any, value: string) => { this.otherDescriptionVisible = value.length > 0 && Number(value) > 0; }}
                />

                <AnimDiv>{this.otherDescriptionVisible && <form.FormsyText
                    name="expensesOtherDescription"
                    required
                    validations="minLength:1"
                    floatingLabelText={ui.__("expenses.otherDescription")}
                    fullWidth={true}
                    value={this.props.user.expenses.otherDescription}
                    validationError={ui.__("error.requiredField")}
                />}</AnimDiv>
            </div >
        );
    }
}


@i18n.injectIntl
@inject("user")
@observer
export class ExpensesForm extends React.Component<RouteComponentProps<{}> & IProps & { onSubmit: (keysSubmittedFields: string[]) => void }, {}> {

    @observable
    formIsValid = false;

    @observable
    otherDescriptionVisible = this.props.user.income.other.value > 0;

    private formRef: any;

    static parseInput(user: User, fields: any) {
        const e = user.expenses;

        e.rent.fromString(fields.expensesRent || "");
        e.utilities.fromString(fields.expensesUtilities);
        e.otherLoans.fromString(fields.expensesOtherLoans);
        e.insurances.fromString(fields.expensesInsurances);
        e.healthInsurance.fromString(fields.expensesHealthInsurance ? fields.expensesHealthInsurance : "0");
        e.numberOfCars = fields.expensesNumberOfCars ? parseInt(fields.expensesNumberOfCars, 10) : 0;
        e.other.fromString(fields.expensesOther);
        e.otherDescription = fields.expensesOtherDescription;
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        // SUCCESS-REDIRECT: user has already fully submitted previously, hard redirect to /loan
        if (this.props.user.successfullySubmitted === true) {
            window.location.replace(window.location.origin + window.location.pathname); // we wont include hash - root page only.
        }
    }

    onSubmit = (fields: any, resetForm: any, invalidateForm: any) => {
        ExpensesForm.parseInput(this.props.user, fields);
        debug.log("### Expenses", this.props.user.expenses);

        const submittedFields = _.compact(_.map(fields as _.Dictionary<any>, (value, key) => {
            return _.isNil(value) ? null : key;
        }));

        this.props.onSubmit(submittedFields);

        this.props.history.push("/documents");
    }

    render() {
        return (
            <pr.FormContainer>
                <Formsy.Form
                    onInvalidSubmit={(fields: any, reset: any, invalidate: any) => formHelpers.invalidateRequiredFields(this.formRef, invalidate)}
                    onValidSubmit={this.onSubmit}
                    onValid={() => { this.formIsValid = true; }}
                    onInvalid={() => { this.formIsValid = false; }}
                    noValidate
                    ref={(c: any) => this.formRef = c}
                >
                    <ExpensesContent user={this.props.user} />
                    {formHelpers.renderActionButton(ui.__("continue"))}
                </Formsy.Form>
            </pr.FormContainer >
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ExpensesForm.tsx